import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactApexChart from "react-apexcharts";
import { Calendar } from "primereact/calendar";
import { DatePicker } from "antd";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { getDashboardData, getProfileData } from "../../../apis/auth";
import { getUserPlanDetails } from "../../../apis/auth";

const EmployeeDashboard = () => {
  const [date, setDate] = useState(new Date("2024"));
  const [profile, setProfile] = useState<any>([]);
  const [smsTokenAmount, setSmsTokenAmount] = useState<string | undefined>();
  const [aadharTokenAmount, setAadharTokenAmount] = useState<string | undefined>();

  const smsCharges = 0.3;
  const aadharCharges = 4;
  const fetchProfileData = async () => {
    try {
      const response = await getProfileData();
      setProfile(response.data);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const [userPlanDetails, setUserPlanDetails] = useState<any>({});

  const fetchUserPlan = async () => {
    const res = await getUserPlanDetails();
    setUserPlanDetails(res?.data);
  };

  useEffect(() => {
    fetchUserPlan();
    fetchProfileData();
    fetchAlldashboardData();
    if (smsTokenAmount) {
      const amount = parseFloat(smsTokenAmount);
      if (!isNaN(amount)) {
      } else {
      }
    }
    if (aadharTokenAmount) {
      const amount = parseFloat(aadharTokenAmount);
      if (!isNaN(amount)) {
      } else {
      }
    }
  }, [smsTokenAmount, aadharTokenAmount]);

  const [dashData, setDashData] = useState<any>();

  const fetchAlldashboardData = async () => {
    const data = {
      start_date: "",
      end_date: "",
    };
    try {
      const response = await getDashboardData(data);
      if (response.status === true) {
        const newResponse = response.data;
        setDashData(newResponse);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const chartsData = [
    dashData?.customerCount?.yearly ? dashData?.customerCount?.yearly : 0,
    dashData?.customerCount?.today ? dashData?.customerCount?.today : 0,
    dashData?.customerCount?.monthly ? dashData?.customerCount?.monthly : 0,
    dashData?.customerCount?.weekly ? dashData?.customerCount?.weekly : 0,
    dashData?.totalCustomer ? dashData?.totalCustomer : 0,
  ];

  const [leavesChart] = useState<any>({
    chart: {
      height: 165,
      type: "donut",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
      },
    },
    dataLabels: {
      enabled: false,
    },

    series: chartsData,
    colors: ["#F26522", "#FFC107", "#E70D0D", "#03C95A", "#0C4B5E"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
    legend: {
      show: false,
    },
  });

  useEffect(() => {
    if (dashData?.emis) {
      let months = Object.keys(dashData?.emis);
      let values = Object.values(dashData?.emis);
      const monthOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      months.sort((a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b));
      const sortedValues = months.map((month) => dashData.emis[month]);

      setPerformanceChart2((prev: any) => {
        const updatedChart = {
          ...prev,
          series: [{ name: "Emi Collected", data: sortedValues }],
          xaxis: { categories: months },
        };

        return updatedChart;
      });
    }
  }, [dashData]);

  const [performance_chart2, setPerformanceChart2] = useState<any>({
    series: [{ name: "Emi Collected", data: [] }],
    chart: { height: 288, type: "area", zoom: { enabled: false } },
    colors: ["#03C95A"],
    dataLabels: { enabled: false },
    stroke: { curve: "straight" },
    title: { text: "Emi Collection", align: "left" },
    xaxis: { categories: [] },
    yaxis: {
      min: 0,
      tickAmount: 5,
      labels: { formatter: (val: number) => val + "K" },
    },
    legend: { position: "top", horizontalAlign: "left" },
  });

  const employeename = [
    { value: "Select", label: "Select" },
    { value: "Anthony Lewis", label: "Anthony Lewis" },
    { value: "Brian Villalobos", label: "Brian Villalobos" },
    { value: "Harvey Smith", label: "Harvey Smith" },
  ];
  const leaveType = [
    { value: "Select", label: "Select" },
    { value: "Medical Leave", label: "Medical Leave" },
    { value: "Casual Leave", label: "Casual Leave" },
    { value: "Annual Leave", label: "Annual Leave" },
  ];

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body;
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="input-icon w-120 position-relative mb-2">
                <span className="input-icon-addon">
                  <i className="ti ti-calendar text-gray-9" />
                </span>
                <Calendar value={date} onChange={(e: any) => setDate(e.value)} view="year" dateFormat="yy" className="Calendar-form" />
              </div>
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 d-flex">
              <div className="card position-relative flex-fill">
                <div className="card-header bg-dark">
                  <div className="d-flex align-items-center">
                    <span className="avatar avatar-lg avatar-rounded border border-white border-2 flex-shrink-0 me-2">
                      <img src={profile?.profile_pic} alt="Img" />
                    </span>
                    <div>
                      <h5 className="text-white mb-1">{profile?.company_name}</h5>
                      <div className="d-flex align-items-center">
                        <p className="text-white fs-12 mb-0">Finacer</p>
                        <span className="mx-1">
                          <i className="ti ti-point-filled text-primary" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <Link to="#" className="btn btn-icon btn-sm text-white rounded-circle edit-top">
                    <i className="ti ti-edit" />
                  </Link>
                </div>
                <div className="card-body">
                  <div className="mb-3">
                    <span className="d-block mb-1 fs-13">Phone Number</span>
                    <p className="text-gray-9">{profile?.phone_number}</p>
                  </div>
                  <div className="mb-3">
                    <span className="d-block mb-1 fs-13">Email Address</span>
                    <p className="text-gray-9">{profile?.email}</p>
                  </div>
                  <div>
                    <span className="d-block mb-1 fs-13">Joined on</span>
                    <p className="text-gray-9">{profile?.createdAt}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-5 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Customer Overview</h5>
                    <div className="dropdown">
                      {/* <Link
                        to="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        2024
                      </Link> */}
                      {/* <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2023
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2022
                          </Link>
                        </li>
                      </ul> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="mb-4">
                        <div className="mb-3">
                          <p className="d-flex align-items-center">
                            <i className="ti ti-circle-filled fs-8  me-1" style={{ color: "rgb(12, 75, 94)" }} />
                            <span className="text-gray-9 fw-semibold me-1">
                              {dashData?.customerCount
                                ? dashData?.customerCount?.monthly +
                                dashData?.customerCount?.today +
                                dashData?.customerCount?.weekly +
                                dashData?.customerCount?.yearly
                                : "0"}
                            </span>
                            Total Customer
                          </p>
                        </div>
                        {/* <div className="mb-3">
                          <p className="d-flex align-items-center">
                            <i
                              className="ti ti-circle-filled fs-8 me-1"
                              style={{ color: "#f26522" }}
                            />
                            <span className="text-gray-9 fw-semibold me-1">
                              {dashData?.customerCount
                                ? dashData?.customerCount?.yearly
                                : "0"}
                            </span>
                            Yearly
                          </p>
                        </div> */}
                        <div className="mb-3">
                          <p className="d-flex align-items-center">
                            <i className="ti ti-circle-filled fs-8 text-danger me-1" />
                            <span className="text-gray-9 fw-semibold me-1">{dashData?.customerCount ? dashData?.customerCount?.monthly : "0"}</span>
                            Monthly
                          </p>
                        </div>
                        <div className="mb-3">
                          <p className="d-flex align-items-center">
                            <i className="ti ti-circle-filled fs-8 text-success  me-1" />
                            <span className="text-gray-9 fw-semibold me-1">{dashData?.customerCount ? dashData?.customerCount?.weekly : "0"}</span>
                            Weekly
                          </p>
                        </div>
                        <div>
                          <p className="d-flex align-items-center">
                            <i className="ti ti-circle-filled fs-8 text-warning me-1" />
                            <span className="text-gray-9 fw-semibold me-1">{dashData?.customerCount ? dashData?.customerCount?.today : "0"}</span>
                            Daily
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-4 d-flex justify-content-md-end">
                        {chartsData && <ReactApexChart id="leaves_chart" options={leavesChart} series={chartsData} type="donut" height={165} />}
                      </div>
                    </div>
                    <div className="col-md-12"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Financer Overview</h5>
                    {/* <div className="dropdown">
                      <Link
                        to="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        2024
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2023
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2022
                          </Link>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                <div className="card-body">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <span className="d-block mb-1">Total Sms Balance</span>
                        <h4>{userPlanDetails?.sms_token_limit || "0"}</h4>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <span className="d-block mb-1">Total Aadhar Balance</span>
                        <h4>{userPlanDetails?.aaddhar_token_limit || "0"}</h4>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <span className="d-block mb-1">Total Employees</span>
                        <h4> {dashData?.totalCustomer ? dashData?.totalCustomer : "0"}</h4>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <span className="d-block mb-1">Total Branches</span>
                        <h4>{dashData?.retailerCount ? dashData?.retailerCount : "0"}</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Projects</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-4 shadow-none mb-md-0">
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6>Account Management</h6>
                            <div className="dropdown">
                              <Link to="#" className="d-inline-flex align-items-center" data-bs-toggle="dropdown">
                                <i className="ti ti-dots-vertical" />
                              </Link>
                              <ul className="dropdown-menu dropdown-menu-end p-3">
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#edit_task"
                                  >
                                    <i className="ti ti-edit me-2" />
                                    Edit
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#delete_modal"
                                  >
                                    <i className="ti ti-trash me-2" />
                                    Delete
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-32.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#">Monthly Expences</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.monthlyExpenses || "0"}</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-32.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#">Yearly Expences</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.yearlyExpenses || "0"}</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-32.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#">Daily Expences</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.todayExpenses || "0"}</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar bg-soft-primary rounded-circle">
                                <i className="ti ti-calendar text-primary fs-16" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">{new Date().toISOString().split("T")[0]}</h6>
                                <span className="fs-13 d-block">today Expences</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between bg-transparent-light border border-dashed rounded p-2 mb-3">
                              <div className="d-flex align-items-center">
                                <span className="avatar avatar-sm bg-success-transparent rounded-circle me-1">
                                  <i className="ti ti-checklist fs-16" />
                                </span>
                                <p>
                                  Total Expences : <span className="text-gray-9">6 </span> /10
                                </p>
                              </div>
                              <div className="avatar-list-stacked avatar-group-sm">
                                <span className="avatar avatar-rounded">
                                  <ImageWithBasePath className="border border-white" src="assets/img/profiles/avatar-06.jpg" alt="img" />
                                </span>
                                <span className="avatar avatar-rounded">
                                  <ImageWithBasePath className="border border-white" src="assets/img/profiles/avatar-07.jpg" alt="img" />
                                </span>
                                <span className="avatar avatar-rounded">
                                  <ImageWithBasePath className="border border-white" src="assets/img/profiles/avatar-08.jpg" alt="img" />
                                </span>
                                <Link className="avatar bg-primary avatar-rounded text-fixed-white fs-12 fw-medium" to="#">
                                  +2
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card shadow-none mb-0">
                        <div className="card-body">
                          <div className="d-flex align-items-center justify-content-between mb-3">
                            <h6>Emis Management</h6>
                            <div className="dropdown">
                              <Link to="#" className="d-inline-flex align-items-center" data-bs-toggle="dropdown">
                                <i className="ti ti-dots-vertical" />
                              </Link>
                              <ul className="dropdown-menu dropdown-menu-end p-3">
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#edit_task"
                                  >
                                    <i className="ti ti-edit me-2" />
                                    Edit
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to="#"
                                    className="dropdown-item rounded-1"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#delete_modal"
                                  >
                                    <i className="ti ti-trash me-2" />
                                    Delete
                                  </Link>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-33.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#"> Yearly Emi's</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.emis?.yearlyEmis || 0}</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-33.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#"> Monthly Emi's</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.emis?.monthlyEmis || 0}</span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                              <Link to="#" className="avatar">
                                <ImageWithBasePath src="assets/img/users/user-33.jpg" className="img-fluid rounded-circle" alt="img" />
                              </Link>
                              <div className="ms-2">
                                <h6 className="fw-normal">
                                  <Link to="#"> Today Emi's</Link>
                                </h6>
                                <span className="fs-13 d-block">{dashData?.emis?.todayEmis || 0}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Loans</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div className="list-group list-group-flush">
                    <div className="list-group-item border rounded mb-3 p-2">
                      <div className="row align-items-center row-gap-3">
                        <div className="col-md-8">
                          <div className="todo-inbox-check d-flex align-items-center">
                            <span>
                              <i className="ti ti-grid-dots me-2" />
                            </span>
                            <div className="strike-info">
                              <h4 className="fs-14 text-truncate">Approved Loans</h4>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                            <i className="fas fa-circle fs-6 me-1" />
                            {dashData?.loans?.approvedLoans || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item border rounded mb-3 p-2">
                      <div className="row align-items-center row-gap-3">
                        <div className="col-md-8">
                          <div className="todo-inbox-check d-flex align-items-center">
                            <span>
                              <i className="ti ti-grid-dots me-2" />
                            </span>
                            <div className="strike-info">
                              <h4 className="fs-14 text-truncate">Disbursed Loans</h4>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                            <i className="fas fa-circle fs-6 me-1" />
                            {dashData?.loans?.disbursedLoans || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="list-group-item border rounded mb-3 p-2">
                      <div className="row align-items-center row-gap-3">
                        <div className="col-md-8">
                          <div className="todo-inbox-check d-flex align-items-center">
                            <span>
                              <i className="ti ti-grid-dots me-2" />
                            </span>
                            <div className="strike-info">
                              <h4 className="fs-14 text-truncate">Pending Loans</h4>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="d-flex align-items-center justify-content-md-end flex-wrap row-gap-3">
                            <i className="fas fa-circle fs-6 me-1" />
                            {dashData?.loans?.pendingLoans || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-5 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Performance</h5>
                    {/* <div className="dropdown">
                      <Link
                        to="#"
                        className="btn btn-white border btn-sm d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        <i className="ti ti-calendar me-1" />
                        2024
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2023
                          </Link>
                        </li>
                        <li>
                          <Link to="#" className="dropdown-item rounded-1">
                            2022
                          </Link>
                        </li>
                      </ul>
                    </div> */}
                  </div>
                </div>
                <div className="card-body">
                  <div>
                    <div className="bg-light d-flex align-items-center rounded p-2">
                      <h3 className="me-2">98%</h3>
                      <span className="badge badge-outline-success bg-success-transparent rounded-pill me-1">12%</span>
                      <span>vs last years</span>
                    </div>
                    <ReactApexChart
                      id="performance_chart2"
                      options={performance_chart2}
                      series={performance_chart2.series}
                      type="area"
                      height={288}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 d-flex">
              <div className="card flex-fill">
                <div className="card-header">
                  <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                    <h5>Payments</h5>
                  </div>
                </div>
                <div className="card-body">
                  <div>
                    <div className="border border-dashed bg-transparent-light rounded p-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <span className="d-block border border-2 h-12 border-dark rounded-5 me-2" />
                          <div>
                            <h6 className="fw-medium mb-1">Today Payments</h6>
                            <p>{dashData?.payments?.todayPayments || 0}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border border-dashed bg-transparent-light rounded p-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <span className="d-block border border-2 h-12 border-dark rounded-5 me-2" />
                          <div>
                            <h6 className="fw-medium mb-1">Montly Payments</h6>
                            <p>{dashData?.payments?.monthlyPayments || 0}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border border-dashed bg-transparent-light rounded p-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <span className="d-block border border-2 h-12 border-dark rounded-5 me-2" />
                          <div>
                            <h6 className="fw-medium mb-1">Yearly Payments</h6>
                            <p>{dashData?.payments?.yearlyPayments || 0}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 d-flex">
              <div className="flex-fill">
                <div className="card card-bg-5 mb-3">
                  <div className="card-body">
                    <div className="text-center">
                      <h5 className="mb-4" style={{ color: "#000000" }}>
                        PayBiA Finance
                      </h5>
                      <span className="avatar avatar-xl avatar-rounded mb-2">
                        <ImageWithBasePath src="favicon.png" alt="Img" />
                      </span>
                      <div className="mb-3"></div>
                      <Link to="https://www.paybiafinance.com/" className="btn btn-sm btn-primary">
                        Website
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="card flex-fill">
                  <div className="card-header">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <h5>EMI(s)</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar flex-shrink-0">
                          <ImageWithBasePath src="assets/img/users/user-27.jpg" className="rounded-circle border border-2" alt="img" />
                        </Link>
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#"> Yearly Emi's</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.yearlyEmis_ || 0}</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#">Total Amount</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.totalYearlyAmount || 0}</p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar flex-shrink-0">
                          <ImageWithBasePath src="assets/img/users/user-27.jpg" className="rounded-circle border border-2" alt="img" />
                        </Link>
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#"> Monthly Emi's</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.totalMonthlyAmount || 0}</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#">Total Amount</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.totalTodayAmount || 0}</p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="d-flex align-items-center">
                        <Link to="#" className="avatar flex-shrink-0">
                          <ImageWithBasePath src="assets/img/users/user-27.jpg" className="rounded-circle border border-2" alt="img" />
                        </Link>
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#"> Today Emi's</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.todayEmis_ || 0}</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="ms-2">
                          <h6 className="fw-normal">
                            <Link to="#">Total Amount</Link>
                          </h6>
                          <p className="fs-13">{dashData?.emisBased?.yearlyEmis_ || 0}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row"></div>
        </div>
      </div>
      <div className="modal fade" id="add_leaves">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Leave</h4>
              <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Employee Name</label>
                      <CommonSelect className="select" options={employeename} defaultValue={employeename[0]} />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Leave Type</label>
                      <CommonSelect className="select" options={leaveType} defaultValue={leaveType[0]} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">From </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{
                            format: "DD-MM-YYYY",
                            type: "mask",
                          }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">To </label>
                      <div className="input-icon-end position-relative">
                        <DatePicker
                          className="form-control datetimepicker"
                          format={{
                            format: "DD-MM-YYYY",
                            type: "mask",
                          }}
                          getPopupContainer={getModalContainer}
                          placeholder="DD-MM-YYYY"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">No of Days</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Remaining Days</label>
                      <input type="text" className="form-control" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Reason</label>
                      <textarea className="form-control" rows={3} defaultValue={""} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light me-2" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Add Leaves
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDashboard;
